export enum AttendanceStatusEnum {
    CHECKED_IN = 'checkin',
    CHECKED_OUT = 'checkout',
}
